import {
  Validatable,
  QuestionnaireStatusModel,
} from "@/core/models";

import {
  FollowUpStatus,
} from "@/core/constants";

export class CompanyFormModel extends Validatable {
  id: number;
  name: string;
  workshopId?: number;
  countyId: number;
  companySectorId: number;
  attendee1Email: string;
  attendee2Email: string;
  attendee1Name: string;
  attendee2Name: string;
  sectorDescription: string;

}
export class CompanyModel extends Validatable {
  id: number;
  name: string;
  workshopId?: number;
  attendee1Id?: number;
  attendee2Id?: number;
  revStatusId: number;
  followUpStatusId: number;
  countyId: number;
  noOfEmployees: number;
  comments: string;
  attendee1Name: string;
  attendee2Name: string;
  revStatusName: string;
  followUpStatusName: string;
  countyName: string;
  companySectorId: number;
  companySectorName: string;
  attendee1Email: string;
  attendee2Email: string;
  lastRevisionId?: number;
  sectorDescription: string;
  skillsConsultantId: number;
  skillsConsultant: string;
}

export class CompanyCollectionModel {
  id: number;
  name: string;
}

export class ParticipantModel {
  userId: number;
  companyName: string;
  companyId: number;
  companySectorName: string;
  companySectorId: number;
  fullName: string;
  email: string;
  hasAttended: boolean;
}

export class ReplaceParticipantModel extends Validatable {
  previousUserId: number;
  workshopId: number;
  companyId: number;
  fullName: string;
  email: string;
  constructor() {
    super();
    this.fullName = "";
    this.email = "";
  }
}

export class CompanyStatusModel {
  id: number;
  name: string;
  revStatusId: number;
  revStatusName: string;
  followUpStatusId: number;
  followUpStatusName: string;
  comments: string;
  questionnaires: QuestionnaireStatusModel[];
}

export class CompanyFollowupStatusModel extends Validatable {
  companyId: number = 0;
  followUpStatusId: number = FollowUpStatus.NA;
  comments: string = "";
  companyFollowedReport: string = "";
  companySkillsReport: string = "";
  jobTitleForHiring: string = "";
  helpNeeded: string = "";
}

export class CompleteRevisionModel extends Validatable {
  questionnaireId: number = 0;
  comments: string = "";
}

export class TransferCompanyModel extends Validatable {
  companyId: number = 0;
  countyId: number = null as any;
  eventDate: Date = new Date();
}
